import { LoadUserFn } from '@common/types/load-user-fn';
import { ISpaceUser, IUser } from '@konova/api-types';
import { createContext, useContext } from 'react';

export type UserContextType = {
  user: IUser | null;
  isLoggedIn: boolean;
  isAdmin: boolean;
  isPlatformAdmin: boolean;
  isAnonymous: boolean;
  spaceUser: ISpaceUser | null;
  setUser: (user: IUser | null) => void;
  loadUser: LoadUserFn;
};

export const UserContext = createContext<UserContextType>({
  user: null,
  spaceUser: null,
  isLoggedIn: false,
  isAdmin: false,
  isPlatformAdmin: false,
  isAnonymous: false,
  loadUser: () => {
    throw new Error('loadUser function not implemented');
  },
  setUser: () => {
    throw new Error('setUser function not implemented');
  },
});

export const useUserContext = () => useContext(UserContext);